import { jsx as _jsx } from "react/jsx-runtime";
export var IconOutlineClose = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b;
    var iconSize = {
        sm: 'vas-size-4',
        md: 'vas-size-6',
        lg: 'vas-size-8',
    };
    return (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24', strokeWidth: '1.5', stroke: 'currentColor', className: iconSize[size], children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'm9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z' }) }));
};
